import React from "react";
import type { Meta, StoryObj } from "@storybook/react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import PdfViewerScreen from "../../screens/PdfViewerScreen";
import { MockedProvider } from "@apollo/client/testing/react";
import { GET_ASSET } from "../../graphql/asset";
import { buildAsset } from "../factories";
import { StoryStackNavigatorContainer } from "../display-helpers";

const Stack = createNativeStackNavigator<{
    PdfViewer: { assetId: string; title?: string; filename?: string };
}>();

const StoryComponent = () => {
    const mocks = [
        {
            request: {
                query: GET_ASSET,
                variables: () => true,
            },
            result: () => {
                return {
                    data: {
                        getAsset: buildAsset({ id: "007" }),
                    },
                };
            },
        },
    ];
    return (
        <MockedProvider mocks={mocks}>
            <StoryStackNavigatorContainer>
                <Stack.Navigator initialRouteName="PdfViewer">
                    <Stack.Screen
                        name="PdfViewer"
                        component={PdfViewerScreen}
                        options={{ headerShown: true, title: "" }}
                        initialParams={{
                            assetId: "007",
                            title: "Le PDF de fou",
                            filename: "pdf-2-fou.pdf",
                        }}
                    />
                </Stack.Navigator>
            </StoryStackNavigatorContainer>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/PDF viewer",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
